"use strict";

var _classCallCheck = require("/builds/bright-technologies/inocrowd/inocrowd-web-platform/frontend/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/builds/bright-technologies/inocrowd/inocrowd-web-platform/frontend/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _mobx = require("mobx");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var AuthService =
/*#__PURE__*/
function () {
  function AuthService() {
    _classCallCheck(this, AuthService);

    this.isLoggedIn = false;
    this.refreshTokenFailed = false;
    this.init = this.init.bind(this);
    this.login = this.login.bind(this);
    this.loginSocial = this.loginSocial.bind(this);
    this.refreshToken = this.refreshToken.bind(this);
    this.getAccessToken = this.getAccessToken.bind(this);
    this.logout = this.logout.bind(this);
  }

  _createClass(AuthService, [{
    key: "_validateUrlConfig",
    value: function _validateUrlConfig() {
      return this._apiUrl && this._apiUrl.length > 0;
    }
  }, {
    key: "_setSession",
    value: function _setSession(authResult) {
      localStorage.setItem('access_token', authResult.access_token);
      localStorage.setItem('refresh_token', authResult.refresh_token);
    }
  }, {
    key: "init",
    value: function init(_ref) {
      var apiUrl = _ref.apiUrl;

      if (apiUrl) {
        this._apiUrl = apiUrl;
        this.isLoggedIn = !!this.getAccessToken();
      } else {
        console.error('Bright Auth: cannot initialize the service without the API URL');
      }
    }
  }, {
    key: "login",
    value: function login(username, password) {
      var _this = this;

      if (!this._validateUrlConfig()) {
        console.error('Bright Auth: API url has not been set!');
        return;
      }

      return _axios2.default.post(this._apiUrl + '/api/login', 'grant_type=password&username=' + username + '&password=' + password).then(function (response) {
        _this._setSession(response.data);

        _this.isLoggedIn = true;
        _this.refreshTokenFailed = false;
        return Promise.resolve(response);
      }).catch(function (error) {
        return Promise.reject(error);
      });
    }
  }, {
    key: "loginSocial",
    value: function loginSocial(token) {
      var _this2 = this;

      if (!this._validateUrlConfig()) {
        console.error('Bright Auth: API url has not been set!');
        return;
      }

      return _axios2.default.post(this._apiUrl + '/api/login', 'grant_type=social&code=' + token).then(function (response) {
        _this2._setSession(response.data);

        _this2.isLoggedIn = true;
        _this2.refreshTokenFailed = false;
        return Promise.resolve(response);
      }).catch(function (error) {
        return Promise.reject(error);
      });
    }
  }, {
    key: "refreshToken",
    value: function refreshToken() {
      var _this3 = this;

      if (!this._validateUrlConfig()) {
        console.error('Bright Auth: API url has not been set!');
        return;
      }

      return _axios2.default.post(this._apiUrl + '/api/login', 'grant_type=refresh_token&refresh_token=' + localStorage.getItem('refresh_token')).then(function (response) {
        _this3._setSession(response.data);

        return Promise.resolve(response);
      }).catch(function (error) {
        _this3.refreshTokenFailed = true;
        return Promise.reject(error);
      });
    }
  }, {
    key: "getAccessToken",
    value: function getAccessToken() {
      return localStorage.getItem('access_token');
    }
  }, {
    key: "logout",
    value: function logout() {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      this.isLoggedIn = false;
      this.refreshTokenFailed = false;
    }
  }]);

  return AuthService;
}();

(0, _mobx.decorate)(AuthService, {
  isLoggedIn: _mobx.observable,
  refreshTokenFailed: _mobx.observable,
  login: _mobx.action,
  loginSocial: _mobx.action,
  logout: _mobx.action,
  refreshToken: _mobx.action
});
exports.default = AuthService;